import { createFileRoute } from '@tanstack/react-router';

import Start from '~/start/Start';
import { isPremiumBlockedSearch, type PremiumBlockedReason } from '~/utils/gameAccessGate';

export type HomeRouteSearch = {
  blocked?: PremiumBlockedReason;
};

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): HomeRouteSearch => ({
    blocked: isPremiumBlockedSearch(search.blocked) ? search.blocked : undefined,
  }),
  component: Start,
});
